import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AccessFlowRuleset } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "../../shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../../ada-access-api-endpoints";

@Injectable({
  providedIn: "root",
})
export class AccessFlowRulesetService {
  private readonly accessFlowUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}

  getAccessFlowRulesets(nullver: number): Observable<AccessFlowRuleset[]> {
    return this.http
      .post<{ accessflowrulesets: AccessFlowRuleset[] }>(
        `${this.accessFlowUrl}${API_ENDPOINTS.ACCESS_FLOW_RULESET.FETCH}`,
        { nullver }
      )
      .pipe(
        map((response) => response.accessflowrulesets),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getAccessFlowRuleset(
    accessflowrulesetid: number
  ): Observable<AccessFlowRuleset> {
    return this.http
      .post<{ accessflowruleset: AccessFlowRuleset }>(
        `${this.accessFlowUrl}${API_ENDPOINTS.ACCESS_FLOW_RULESET.GET}`,
        { accessflowrulesetid }
      )
      .pipe(
        map((response) => response.accessflowruleset),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getAccessFlowRulesetByaccessFlowId(
    accessflowid: number
  ): Observable<AccessFlowRuleset> {
    return this.http
      .post<{ accessflowruleset: AccessFlowRuleset }>(
        `${this.accessFlowUrl}${API_ENDPOINTS.ACCESS_FLOW_RULESET.GET_BY_ACCESS_FLOW_ID}`,
        { accessflowid }
      )
      .pipe(
        map((response) => response.accessflowruleset),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  createAccessFlowRuleset(
    accessflowrulesetid: number,
    rulesetType: string,
    rulesetid: number
  ): Observable<AccessFlowRuleset> {
    return this.http
      .post<AccessFlowRuleset>(
        `${this.accessFlowUrl}${API_ENDPOINTS.ACCESS_FLOW_RULESET.CREATE}`,
        {
          accessflowrulesetid,
          rulesetType,
          rulesetid,
        }
      )
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  updateAccessFlowRuleset(
    accessflowid: number,
    accessflowrulesetid: number,
    rulesetType: string,
    rulesetid: number
  ): Observable<AccessFlowRuleset> {
    return this.http
      .post<AccessFlowRuleset>(
        `${this.accessFlowUrl}${API_ENDPOINTS.ACCESS_FLOW_RULESET.UPDATE}`,
        {
          accessflowid,
          accessflowrulesetid,
          rulesetType,
          rulesetid,
        }
      )
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  deleteAccessFlowRuleset(
    accessflowrulesetid: number
  ): Observable<AccessFlowRuleset[]> {
    return this.http
      .post<AccessFlowRuleset[]>(
        `${this.accessFlowUrl}${API_ENDPOINTS.ACCESS_FLOW_RULESET.DELETE}`,
        { accessflowrulesetid }
      )
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }
}
